/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Select_All_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select All Events with Errors" |
*
* @param {Style_Guide_Select_All_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_select_all_aria_label = /** @type {((inputs?: Style_Guide_Select_All_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Select_All_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner tous les evenements avec erreurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ereignisse mit Fehlern auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi con errori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все события с ошибками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todos los eventos con errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择所有出错的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーのあるすべてのイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटियों वाले सभी इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar todos os eventos com erros")
	return /** @type {LocalizedString} */ ("Select All Events with Errors")
});